import React, {Component} from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchUser, logoutUser} from '../../actions/firebase_actions';
import {changeColor, clearDraw} from '../../actions/ts_overlay_actions.js';
import {changeMap} from '../../actions/ts_map_actions.js';
import {updateModal} from '../../actions/modal.js';
import {setActive} from '../../actions/ts_active_actions.js';
import {updateCanvas} from '../../actions/ts_canvas_actions.js';
import {addNewStrat} from '../../actions/ts_userData_actions.js';
import utils from '../../utils/config.js'
import Menu from '../menu/';
import Gears4 from '../menu/games/gears4.jsx';
import Gears5 from '../menu/games/gears5.jsx';
import CS_GO from '../menu/games/csgo.jsx';
import Lawbreakers from '../menu/games/lawbreakers.jsx';
import Rainbowsix from '../menu/games/rainbowsix.jsx';
import Bank from '../menu/games/bank.jsx';
import Clubhouse from '../menu/games/clubhouse.jsx';
import Sports from '../menu/games/sports.jsx';
import Valorant from '../menu/games/valorant.jsx';
import RogueCompany from '../menu/games/roguecompany.jsx';
import Login from '../login/';
import Logout from '../logout/';
import About from '../about/';
import Donate from '../donate/';
import Playbook from '../playbook/';
import StratDetails from '../stratDetails/';
import Profile from '../profile/';
import Register from '../register/';
import Privacy from '../documents/privacy/';
import Terms from '../documents/terms/';
import License from '../documents/license/';
import Copyright from '../documents/copyright/';
import Tools from '../tools/';
import {Button, Modal, Grid,Row,Col,Clearfix, ButtonToolbar, DropdownButton, MenuItem, ButtonGroup,Dropdown} from 'react-bootstrap';
import {getGameTitle, getMapTitle, getSubTitle} from '../../utils/maps/titleUtil.js';
import {TS_EMAIL,TS_PASS} from '../../actions/types';
import {
  GEARS4,
  CSGO,
  SPORTS,
  LAWBREAKERS,
  TRICKSTRAT,
  WELCOME,
  ICON,
  RS6,
  BANK1,BANK2,BANK3,BANK4,
  CLUBHOUSE1, CLUBHOUSE2, CLUBHOUSE3, CLUBHOUSE4,
  GEARS5,
  VALORANT,
  ROGUECOMPANY
} from '../../utils/maps/types';
import Icon from '../../images/trickstrat/ts_icon.png';
import PlaybookIcon from '../../images/trickstrat/playbook.png';
import PlaybookWhite from '../../images/trickstrat/playbookWhite.png';


var Nav = React.createClass({
  getInitialState: function() {

              return {
                  width: window.innerWidth,
              }
      },

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  },

  // make sure to remove the listener
  // when the component is not mounted anymore
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  },

  handleWindowSizeChange(){
    this.setState({width: window.innerWidth});
  },

  hideModal() {
    var {dispatch} = this.props;
    dispatch(updateModal(false,null));
  },

  showModal(content) {
    var {dispatch} = this.props;
    dispatch(updateModal(true,content));
  },

  renderModal(content) {
    var modalContent;
    var {dispatch} = this.props;
    if (content == 'login') {
      modalContent = <Login/>;
    }
    if (content == 'register') {
        modalContent = <Register/>;
    }
    if (content == 'about') {
        modalContent = <About/>;
    }
    if (content == 'donate') {
      modalContent = <Donate/>;
  }
    if (content == 'profile') {
        modalContent = <Profile/>;
    }
    if (content == 'menu') {
       modalContent =<Menu/>;
    }
    if (content == GEARS4) {
      modalContent = <Gears4/>;
    }
    if (content == GEARS5) {
      modalContent = <Gears5/>;
    }
    if (content == CSGO) {
      modalContent = <CS_GO/>;
    }
    if (content == LAWBREAKERS) {
      modalContent = <Lawbreakers/>;
    }
    if (content == RS6) {
      modalContent = <Rainbowsix/>;
    }
    if (content == SPORTS) {
      modalContent = <Sports/>;
    }
    if (content == 'terms') {
       modalContent =<Terms/>;
    }
    if (content == 'license') {
       modalContent =<License/>;
    }
    if (content == 'privacy') {
       modalContent =<Privacy/>;
    }
    if (content == 'copyright') {
       modalContent =<Copyright/>;
    }
    if (content == 'playbook') {
       modalContent =<Playbook/>;
    }
    if (content == 'stratDetails') {
       modalContent =<StratDetails/>;
    }
    if (content == BANK1) {
      modalContent = <Bank/>;
    }
    if (content == BANK2) {
      modalContent = <Bank/>;
    }
    if (content == BANK3) {
      modalContent = <Bank/>;
    }
    if (content == BANK4) {
      modalContent = <Bank/>;
    }
    if (content == CLUBHOUSE1) {
      modalContent = <Clubhouse/>;
    }
    if (content == CLUBHOUSE2) {
      modalContent = <Clubhouse/>;
    }
    if (content == CLUBHOUSE3) {
      modalContent = <Clubhouse/>;
    }
    if (content == CLUBHOUSE4) {
      modalContent = <Clubhouse/>;
    }
    if (content == VALORANT) {
      modalContent = <Valorant/>;
    }
    if (content == ROGUECOMPANY) {
      modalContent = <RogueCompany/>;
    }
    this.showModal(modalContent)
  },

  changeColor(color) {
    var {dispatch} = this.props;
    dispatch(changeColor(color));
  },

  clearDraw() {
    var {dispatch, overlay} = this.props;
    dispatch(clearDraw(overlay.color));
  },

  logout(){
    var {dispatch,map,overlay} = this.props;
    localStorage.removeItem(TS_EMAIL);
    localStorage.removeItem(TS_PASS);
    dispatch(changeMap(TRICKSTRAT,WELCOME));
    dispatch(clearDraw(overlay.color,overlay.color1,overlay.color2));
    dispatch(updateModal(false,null));
    dispatch(setActive(null,null));
    dispatch(updateCanvas(null,null,[]));
    dispatch(logoutUser());
  },

  renderUserMenu(currentUser) {
    // if current user exists and user id exists than make user navigation
    var divBlackCircle = {
      float: 'right'
    }
    var floatRight = {
      float:'right',
      marginRight:'-15',
      marginTop:'-10'
    }
    var displayName = "";
    if (currentUser && currentUser.uid && currentUser.emailVerified){
    displayName =  this.props.currentUser.displayName;
    }
    var img =   <span><span className="fa-fw displayName">{displayName}</span> <i className="fa fa-user fa-fw fa-sm"></i></span>
    if (currentUser && currentUser.uid && currentUser.emailVerified) {
      return [
    <div style={floatRight}>
    <ButtonGroup bsStyle={false}  className="navbar-brand">
    <DropdownButton pullRight={true} bsStyle={false} className="divDisplayName"  title={img}>
      <Clearfix>
     <MenuItem className="menuItem" eventKey="1"><Link className="menuItemText" onClick={(event) => {this.renderModal('playbook');}}><span>Playbook</span></Link></MenuItem>
     <MenuItem className="menuItem" eventKey="1"><Link className="menuItemText" onClick={(event) => {this.renderModal('profile');}}><span >Profile</span></Link></MenuItem>
     <MenuItem className="menuItem" eventKey="1"><Link onClick={(event) => {this.renderModal('about');}} className="menuItemText"><span>About</span></Link></MenuItem>
     <MenuItem  divider/>
     <MenuItem className="menuItem" eventKey="3"><Link className="menuItemText" onClick={(event) => {this.renderModal('terms');}}>Terms of Use</Link></MenuItem>
     <MenuItem className="menuItem" eventKey="4"><Link className="menuItemText" onClick={(event) => {this.renderModal('license');}}>User Agreement</Link></MenuItem>
     <MenuItem className="menuItem" eventKey="5"><Link className="menuItemText" onClick={(event) => {this.renderModal('privacy');}}>Privacy Policy</Link></MenuItem>
     <MenuItem className="menuItem" eventKey="6"><Link className="menuItemText" onClick={(event) => {this.renderModal('copyright');}}>Copyright Policy</Link></MenuItem>
     <MenuItem divider/>
     <MenuItem className="menuItem" eventKey="2"><Link className="menuItemText"  onClick={this.logout}>Logout</Link></MenuItem>
 </Clearfix>
    </DropdownButton>
  </ButtonGroup>
</div>
        ];
    } else {
      return
        }
    },
    renderTitle(game,map2,isSmallScreen) {
    if (isSmallScreen)return;
    var {currentUser, map} = this.props;
    var gameTitle = getGameTitle(game);
    var mapTitle = getMapTitle(map2);
    var subTitle = 'Esports Playbook';
    if (map.map == 'SKETCH')subTitle = "Sketch";
    /*if (currentUser && currentUser.uid && map.map == 'SKETCH')
    {
      subTitle = getSubTitle(Math.floor(Math.random() * 4));
    }*/
    if (gameTitle != undefined && gameTitle != '' && mapTitle != undefined && mapTitle != 'WELCOME' && mapTitle != 'SKETCH')
      {
        return (
              <span onClick={(event) => {this.renderModal(game);}}><Link className="mapTitleText" >{gameTitle}</Link > | <Link className="mapTitleText">{mapTitle}</Link> </span>);
      } else {
        return (<span className="mapTitleText" onClick={(event) => {this.renderModal('menu');}}> {subTitle} </span>);
      }
    },
    render() {
      var {modal, currentUser, map, userData, active, dispatch, canvas} = this.props;
      var version = utils.getVersion();
      var copyright = utils.getCopyright();
      var appName = utils.getAppName();
      var maxStratCount = utils.getMaxStratCount();
      var addNewStrat = '';
      var stratCount = 0;
      var stratName = '';
      var tools = <Tools/>;
      if (userData.data != null && userData.data != undefined)
      {
        if (userData.data.strats != null && userData.data.strats != undefined)
        {
          stratCount = Object.keys(userData.data.strats).length;
        }
      }
      if (stratCount < maxStratCount && map.map != "WELCOME" && canvas.history && canvas.history.length > 0 && (active.stratId == null || active.stratId == undefined || active.stratId == "")){
          addNewStrat = <span onClick={(event) => {this.renderModal('stratDetails');}} className="lightblue">&#x2190; Add to Playbook</span>
      }
      if (active.stratId != null && userData.data != null){
        if (userData.data.strats[active.stratId] != null)
        {
          if (userData.data.strats[active.stratId].name != null)
          {
                var name = userData.data.strats[active.stratId].name;
          }
        }
          tools = <span className="navbar-brand mapTitleText floatRight" onClick={(event) => {  dispatch(updateModal(true,<StratDetails strat={userData.data.strats[active.stratId]} id={active.stratId}/>));}}>
            <span className="lightblue">{name} <i className="fa fa-sticky-note-o fa-fw"></i></span>
            </span>
      }

      var displayName =  '';

      var about = <Link onClick={(event) => {this.renderModal('about');}} className="navbar-brand"><span><div><b>?</b></div></span></Link>;
      if (currentUser && currentUser.uid && currentUser.emailVerified){
      displayName =  this.props.currentUser.displayName;
      about = null;
      }
      var floatRight = {
        float:"right"
      }
      var floatLeft = {
        float:"left",
        fontSize:"12px",
        cursor:"default",
        paddingTop:"0px"
      }
      const {width} = this.state;
      const isSmallScreen = width <= 600;
      return (
          <div>
            <header className="navbar navbar-inverse" id="top" role="banner">
              <div className="container">

                <div style={floatRight}>
                  {tools}
                  {about}
                  <br/>
                  {this.renderUserMenu(this.props.currentUser)}
                </div>
                <div className="navbar-header">
                  <Link to="/" className="navbar-brand"><span className="floatLeft" onClick={(event) => {this.renderModal('menu');}}>{appName}&nbsp;</span>{this.renderTitle(map.game, map.map,isSmallScreen)}{stratName}
                    <br/><span className="mapTitleText floatLeft saveStyle"><span onClick={(event) => {this.renderModal('playbook');}}><img width="25" src={PlaybookWhite}></img> </span>{addNewStrat}</span>
                 </Link>
              </div>
              </div>
            </header>
            <Modal show={modal.show} onHide={this.hideModal} dialogClassName="custom-modal" enforceFocus={true}>
              <Modal.Body >
                  <span style={floatRight} onClick={this.hideModal}>X</span>
                {modal.content}
              </Modal.Body>
            </Modal>

            </div>
      );
    }
  });

  module.exports = connect((state) => {
    return {currentUser: state.currentUser, map: state.map, overlay: state.overlay, modal: state.modal, canvas: state.canvas, userData : state.userData, active : state.active}
  })(Nav);



// WEBPACK FOOTER //
// ./src/app/components/nav/index.jsx